import { render, staticRenderFns } from "./CommentComposer.vue?vue&type=template&id=7f6f962b&scoped=true"
import script from "./CommentComposer.vue?vue&type=script&lang=js"
export * from "./CommentComposer.vue?vue&type=script&lang=js"
import style0 from "./CommentComposer.vue?vue&type=style&index=0&id=7f6f962b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6f962b",
  null
  
)

export default component.exports